<script>
import { onMount } from "svelte";
import { sineInOut } from "svelte/easing";
import { fly } from "svelte/transition";

import { cn } from "../../utils";
import { MoveUp } from "../icons";

export let showOnPx = 400;
let hidden = true;

// function smoothscroll() {
//   var currentScroll =
//     document?.documentElement.scrollTop || document?.body.scrollTop;
//   if (currentScroll > 0) {
//     console.log("currentScroll", currentScroll);
//     window.requestAnimationFrame(smoothscroll);
//     window.scrollTo(0, currentScroll - currentScroll / 5);
//   }
// }

function goTop() {
  // console.log("goTop");
  // document.body.scrollIntoView({ block: "end", behavior: "smooth" });
  // document.body.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
  // window?.scrollTo(0, 0);
  // window?.scrollTo({ top: 0, behavior: "smooth" })
  window?.scrollTo({ top: 0, behavior: "smooth" });
  // smoothscroll();
}

function scrollContainer() {
  return document?.documentElement || document?.body;
}

function handleOnScroll() {
  if (!scrollContainer()) {
    return;
  }

  if (scrollContainer().scrollTop > showOnPx) {
    hidden = false;
  } else {
    hidden = true;
  }
}

onMount(() => {
  handleOnScroll();
});

let options = { duration: 250, easing: sineInOut };

const buttonClass = cn(
  "transition-all",
  "bg-black",
  "dark:bg-white",
  "text-base-1",
  "hover:bg-base-11",
  "dark:hover:bg-base-a11",
  "hover:text-base-2",
  "p-1",
  "rounded-full",
  "fixed",
  "bottom-16",
  "right-2",
  "m-0",
  "z-50",
);
</script>

<svelte:window on:scroll={handleOnScroll} />

{#if !hidden}
  <button transition:fly={{ ...options, x: 150 }} on:click={goTop} class={buttonClass}><MoveUp class="size-8" /></button
  >
{/if}
